/**
 * @file dateTime filters
 * @author fuqiang15(fuqiang15@baidu.com)
 */

import format from 'date-fns/format';
import isValid from 'date-fns/is_valid';
import {isPlainObject, defaults} from 'lodash';
import {parseDate} from '@baidu/ve-ria/utils/date';

const defaultConfig = {
    inputFormat: 'YYYYMMDDHHmmss',
    outputFormat: 'YYYY-MM-DD HH:mm:ss',
    fallbackText: '-'
};


// 这个方法来自ve-ria，ve-ria暂时没有暴露出来，先拿来用
function formatTime(
    time,
    {
        inputFormat = defaultConfig.inputFormat,
        outputFormat = defaultConfig.outputFormat,
        fallbackText = defaultConfig.fallbackText
    } = {}
) {
    time = parseDate(time);
    return isValid(time)
        ? format(time, outputFormat || 'YYYY-MM-DD HH:mm:ss')
        : fallbackText || '-';
}

// 生成一些便于传递fallbackText的filter
function timeDefault(val, fallbackText, extra = {}) {
    fallbackText = isPlainObject(fallbackText) ? fallbackText : {fallbackText};
    fallbackText = defaults(fallbackText, extra, defaultConfig);
    return formatTime(val, fallbackText);
}

// 暴露出去, extra 参数是内部使用
export function timeDash(val, fallbackText) {
    return timeDefault(val, fallbackText);
}

export function timeDot(val, fallbackText) {
    return timeDefault(val, fallbackText, {outputFormat: 'YYYY.MM.DD HH:mm:ss'});
}

export function endTimeDot(val, fallbackText) {
    return timeDefault(val, fallbackText, {outputFormat: 'YYYY.MM.DD 23:59:59'});
}

export function dateDash(val, fallbackText) {
    return timeDefault(val, fallbackText, {outputFormat: 'YYYY-MM-DD'});
}

export function dateDot(val, fallbackText) {
    return timeDefault(val, fallbackText, {outputFormat: 'YYYY.MM.DD'});
}
